import PropTypes from "prop-types";
import { useCallback } from "react";
import { useDropzone } from "react-dropzone";

import Icon from "components/ShellV2/Icon";
import UploadHelpButton from "components/UploadHelpButton";
import Chip from "./Chip";

/* Design's dashed upload card (Ficheiros section): icon, bold title, format
   hint and a ghost button. The whole card is a react-dropzone target; the
   selected files replace the hint as chips. */
export default function FileDrop({ icon, title, hint, files, setFiles, multiple, buttonLabel }) {
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length > 0) setFiles(acceptedFiles);
    },
    [setFiles]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, multiple });

  /* eslint-disable react/jsx-props-no-spreading */
  return (
    <div {...getRootProps({ className: `rec-filedrop${isDragActive ? " drag" : ""}` })}>
      <input {...getInputProps()} />
      <Icon name={icon} />
      <div className="rec-filedrop-title">{title}</div>
      {files.length > 0 ? (
        <div className="rec-filedrop-files">
          {files.map((file) => (
            <Chip key={file.path || file.name} tone="teal">
              <Icon name="description" style={{ fontSize: 13 }} />
              {file.path || file.name}
            </Chip>
          ))}
        </div>
      ) : (
        <div className="rec-filedrop-hint">{hint}</div>
      )}
      <div className="flex items-center justify-center gap-2 flex-wrap">
        <span className="rec-btn-ghost rec-btn-sm pointer-events-none">
          <Icon name="upload_file" />
          {buttonLabel}
        </span>
        <UploadHelpButton />
      </div>
    </div>
  );
  /* eslint-enable react/jsx-props-no-spreading */
}

FileDrop.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.node.isRequired,
  hint: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  files: PropTypes.array,
  setFiles: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  buttonLabel: PropTypes.node.isRequired,
};

FileDrop.defaultProps = {
  icon: "upload_file",
  hint: null,
  files: [],
  multiple: false,
};
